import { render, staticRenderFns } from "./FullSpin.vue?vue&type=template&id=4354a90e&"
import script from "./FullSpin.vue?vue&type=script&lang=js&"
export * from "./FullSpin.vue?vue&type=script&lang=js&"
import style0 from "./FullSpin.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports